<template>
  <div class="log-emission">
    <div>
      <div class="log-emission-any">
        <span class="trend-title">全年运输能源消耗</span>
        <el-input type="text" placeholder="请输入" v-model="tableDate.energyConsume">
          <template slot="suffix">吨标煤</template>
        </el-input>
      </div>
      <div class="log-emission-any">
        <span class="trend-title">全年减少碳排放</span>
        <el-input type="text" placeholder="请输入" v-model="tableDate.reduCarbon">
          <template slot="suffix">公斤</template>
        </el-input>
      </div>
      <div class="log-emission-any">
        <span class="trend-title">新能源用量</span>
        <el-input type="text" placeholder="请输入" v-model="tableDate.newEnergy">
          <template slot="suffix">吨标煤</template>
        </el-input>
      </div>
      <div class="log-emission-any">
        <span class="trend-title">柴油用量</span>
        <el-input type="text" placeholder="请输入" v-model="tableDate.diesel">
          <template slot="suffix">吨标煤</template>
        </el-input>
      </div>
      <div class="log-emission-any">
        <span class="trend-title">汽油用量</span>
        <el-input type="text" placeholder="请输入" v-model="tableDate.gasoline">
          <template slot="suffix">吨标煤</template>
        </el-input>
      </div>
    </div>

    <div class="trend-title1">安全趋势</div>
    <div>
      <table class="mytable">
        <thead>
          <tr>
            <th v-for="(mon,index) in month" :key="index">{{mon}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <el-input v-model="tableDate.oneSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.twoSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.threeSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.fourSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.fiveSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.sixSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.sevenSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.eightSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.nineSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.tenSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.elevenSafe" placeholder="请输入"></el-input>
            </td>
            <td>
              <el-input v-model="tableDate.twelveSafe" placeholder="请输入"></el-input>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="trend-title1">节能减排</div>
    <div class="save-box">
      <div>
        <span style="width:10rem" class="trend-title">年份</span>
        <span style="width:15rem" class="trend-title">燃油车运输吨位</span>
        <span style="width:15rem" class="trend-title">新能源车运输吨位</span>
        <!-- <el-button @click="addLogEms" size="small" type="success" icon="el-icon-plus">添加</el-button> -->
        <i @click="addLogEms" class="el-icon el-icon-circle-plus-outline f_green" style="margin-top:10px"></i>
      </div>
      <div v-for="(msg,index) in oilCarDate" :key="index" class="log-emission-year">
        <el-date-picker
          v-model="msg.safeYear"
          type="year"
          value-format="yyyy"
          placeholder="选择日期">
        </el-date-picker>
        <el-input type="number" placeholder="请输入" v-model="msg.fuelTraffic">
          <template slot="suffix">吨</template>
        </el-input>
        <el-input type="number" placeholder="请输入" v-model="msg.newEnergy">
          <template slot="suffix">吨</template>
        </el-input>
        <i @click="removeLogEms(msg.id,index)" class="el-icon el-icon-remove-outline f_red"></i>
        <!-- <el-button @click="removeLogEms(msg.id,index)" style="margin-left:1rem" type="danger" icon="el-icon-minus">删除</el-button> -->
      </div>
    </div>
    <div class="last-save">
      <el-button :loading="emissLoading" size="small" @click="saveEmis" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/transportation/transportation'
export default {
  data(){
    return{
      emissLoading:false,//加载状态
      oilCarDate:[
        {safeYear:'',fuelTraffic:'',newEnergy:''}
      ],
      //通用循环数据
      month:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      tableDate:{
        oneSafe:'',
        twoSafe:'',
        threeSafe:'',
        fourSafe:'',
        fiveSafe:'',
        sixSafe:'',
        sevenSafe:'',
        eightSafe:'',
        nineSafe:'',
        tenSafe:'',
        elevenSafe:'',
        twelveSafe:'',
        energyConsume:'',//全年运输能源消耗
        reduCarbon:'',//全年减少碳排放
        newEnergy:'',//新能源用量
        diesel:'',//柴油用量
        gasoline:'',//汽油用量
      },
    }
  },
  mounted(){
    this.getEmis()
  },
  methods:{
    //保存数据
    saveEmis(){
      this.emissLoading = true;
      let obj = {}
      obj.logistReduct = this.tableDate
      obj.yearList = this.oilCarDate
      api.saveReduct(obj).then(res=>{
        if(res.code==10000){
          this.emissLoading = false;
          this.getEmis()
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
          this.emissLoading = false;   
          return;      
        }
      })
    },
    //获取数据
    getEmis(){
      api.getReduct().then(res=>{
        if(res.code==10000){
          if(res.data.list.length!=0){
            this.tableDate = res.data.list[0]
          }else{
            this.tableDate = {}
          }
        }
      })
      api.getReductDown().then(data=>{
        if(data.code==10000){
          if(data.data.length!=0){
            let _arr = data.data.map(item=>{
              return {
                safeYear:item.safeYear?item.safeYear.toString():'',
                fuelTraffic:item.fuelTraffic,
                newEnergy:item.newEnergy,
                id:item.id,
              }
            })
            this.oilCarDate = _arr
          }
        }
      })
    },
    //删除一行减排
    removeLogEms(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delReduct([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getEmis()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.oilCarDate.splice(index,1)
      }
    },
    //添加一行减排
    addLogEms(){
      this.oilCarDate.push({safeYear:'',fuelTraffic:'',newEnergy:''})
    },
  }
}
</script>
<style lang="less" scoped>
.log-emission{ padding-top:10px;
  .trend-title1{ position: relative; font-weight: bold; color: #24ffb1; font-size: .9rem; padding-left: 10px; border-left: #24ffb1 solid 5px; display: inline-block; margin: 1.6rem 0 30px;}
  .log-emission-any{ display: inline-block; 
    .trend-title{ width: 8.5rem;}
    .el-input{ width: 10rem;}
  }
  .save-box{
    .trend-title{ text-align: center;}
    i{ font-size: 1.2rem; font-weight: bold; margin-left: 1rem; vertical-align: middle;}
    .log-emission-year{
      .el-input{ width: 15rem;}
      .el-date-editor.el-input{ width: 10rem;}
    }
  }
}
</style>